










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Infoblock extends Vue {
  @Prop({ type: String, default: '' })
  readonly name!: string;

  @Prop({ type: Boolean, default: false })
  readonly bold!: boolean;

  @Prop({ type: String, default: '' })
  readonly link!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/contract/components/infoblock/Infoblock.vue